import { JSX } from 'react';
import { Report, ReportSectionName } from '../common/types/reports';

/**
 * Report steps that are not  persisted in the "reports" field (like: choose clients, etc)
 */
export enum ReportSystemSteps {
  SelectClient = 'Choose client',
  SelectSections = 'Choose sections',
  SelectFna = 'Choose FNA',
}

export type ReportFullStepList = ReportSectionName | ReportSystemSteps;

export interface ReportSectionComponentProps {
  /**
   * Optional url to the template file url (pdf).
   * If it's provided, the section will be handled manually (uploading/download files by user)
   */
  templateFileUrl?: string;
  availableSections: ReportFullStepList[];
  sectionName: ReportFullStepList;
  report: Report;
  onClickBack: () => void;
  /**
   * Callback to be called when the user clicks on the "Next" button
   * @param UpdatedReport - Optional updated report to be used instead of the current one. Needed for the "select sections" step
   */
  onClickNext: (UpdatedReport?: Report) => void;
  /**
   * Flat that indicates if some async operation is in progress
   */
  isLoading: boolean;
}

export type ReportSectionComponentType = (props: ReportSectionComponentProps) => JSX.Element;
